import React, { useMemo, useState } from 'react';
import { Layout } from '../../components/Layout';
import AccountExchanges from './Exchanges';
import AccountSubscriptions from './Subscriptions';
import AccountSettings from './Settings';
import BasketSettings from './BasketSettings';

export enum AccountTabs {
  Settings = 'SETTINGS',
  Subscriptions = 'SUBSCRIPTIONS',
  Exchanges = 'EXCHANGES',
  Baskets = 'BASKETS',
}

const Account = () => {
  const [activeTab, setActiveTab] = useState(AccountTabs.Exchanges);

  const sections = useMemo(() => {
    return [
      {
        label: 'Settings',
        isActive: activeTab === AccountTabs.Settings,
        onClick: () => setActiveTab(AccountTabs.Settings),
      },
      {
        label: 'Subscriptions',
        isActive: activeTab === AccountTabs.Subscriptions,
        onClick: () => setActiveTab(AccountTabs.Subscriptions),
      },
      {
        label: 'Exchanges',
        isActive: activeTab === AccountTabs.Exchanges,
        onClick: () => setActiveTab(AccountTabs.Exchanges),
      },
      {
        label: 'Baskets',
        isActive: activeTab === AccountTabs.Baskets,
        onClick: () => setActiveTab(AccountTabs.Baskets),
      },
    ];
  }, [activeTab]);

  return (
    <Layout>
      <Layout.SideMenu>
        <Layout.SideMenuSection>
          <Layout.SideMenuTitle title="Sections" count={sections.length} />
          <>
            {sections.map((section) => (
              <Layout.SideMenuItem
                key={section.label}
                id={section.label}
                label={section.label}
                isActive={section.isActive}
                onClick={section.onClick}
              />
            ))}
          </>
        </Layout.SideMenuSection>
      </Layout.SideMenu>

      <Layout.Content>
        {activeTab === AccountTabs.Settings ? <AccountSettings /> : undefined}
        {activeTab === AccountTabs.Subscriptions ? (
          <AccountSubscriptions />
        ) : undefined}
        {activeTab === AccountTabs.Exchanges ? <AccountExchanges /> : undefined}
        {activeTab === AccountTabs.Baskets ? <BasketSettings /> : undefined}
      </Layout.Content>
    </Layout>
  );
};

export default Account;
